import { render, staticRenderFns } from "./FieldTypeEditor.vue?vue&type=template&id=2a8005b3&"
import script from "./FieldTypeEditor.vue?vue&type=script&lang=js&"
export * from "./FieldTypeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports